import gql from 'graphql-tag';
import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'get_houseRules_lodgingCancellationPolicy';

const lodgingCancellationPolicyQuery = gql`
query ${OPERATION_NAME}($arrivalDate: String, $unitUrl: String!, $isIpmNonGuaranteedPricing: Boolean) {
    houseRules(unitUrl: $unitUrl, arrivalDate: $arrivalDate, isIpmNonGuaranteedPricing: $isIpmNonGuaranteedPricing) {
        lodgingCancellationPolicy {
            policyType
            undatedPolicyText
            cancellationPolicyPeriods{
                label
            }
            cancellationPolicyLabel {
                label
                date
                isFullRefundWindow
            }
            cancellationTimelinePeriods {
                timelineLabel
                refundPercent
                refundWindowLabel
                shortDateLocalized
                isPast
                isActive
                iconCode
            }
            nonRefundableFeeLabel
        }
    }
}`;

async function lodgingCancellationPolicyGraphQl({
    locale,
    arrivalDate,
    unitUrl,
    isIpmNonGuaranteedPricing
}) {
    try {
        return await graphqlQuery(
            OPERATION_NAME,
            lodgingCancellationPolicyQuery,
            {arrivalDate, unitUrl, isIpmNonGuaranteedPricing},
            locale
        );
    } catch (e) {
        return null;
    }
}

export default lodgingCancellationPolicyGraphQl;
export {lodgingCancellationPolicyGraphQl, OPERATION_NAME, lodgingCancellationPolicyQuery};
